import { clearObject } from "@/modules/utils";
import { useApiWithAuth } from "@/modules/api";
import { PermissionPayload } from "@/modules/auth";
import { ClientePayload } from "@/modules/business/cliente/clienteBusiness";

interface ContratoTransportadorFilterPayload {
  idCliente?: number | null;
  idTransportador?: number | null;
  idOrgao?: number | null;
  tipoSolicitacao?: number | null;
  ativo?: boolean | null;
}

interface ContratoTransportadorPayload {
  idContratoTransportador?: number | null;
  idTransportador?: number | null;
  nomeTransportador?: string | null;
  cpfCnpjTransportador?: string | null;
  idOrgao?: number | null;
  tipoSolicitacao?: number | null;
  precoFixo?: number | null;
  dataInicio?: Date | null;
  dataFim?: Date | null;
  flAtivo?: boolean | null;
  cliente?: ClientePayload | null;
  permissionInfo?: PermissionPayload;
}

const useContratoTransportadorService = () => {
  const { data, loading, get, post, put, patch } = useApiWithAuth();

  const searchContratos = (
    filter: ContratoTransportadorFilterPayload,
    page: number
  ): Promise<void> => {
    return get("/contrato-transportador", {
      ...clearObject(filter),
      ...{
        page: page
      }
    });
  };

  const getContrato = (idContratoTransportador: number): Promise<void> => {
    return get(`/contrato-transportador/${idContratoTransportador}`);
  };

  const saveNewContrato = (
    entity: ContratoTransportadorPayload
  ): Promise<void> => {
    return post("/contrato-transportador", entity);
  };

  const updateContrato = (
    idContratoTransportador: number,
    entity: ContratoTransportadorPayload
  ): Promise<void> => {
    return put(`/contrato-transportador/${idContratoTransportador}`, entity);
  };

  const shelveContrato = (idContratoTransportador: number): Promise<void> => {
    return patch(`/contrato-transportador/${idContratoTransportador}/arquivar`);
  };

  const safeContrato = (
    entity?: ContratoTransportadorPayload | null
  ): ContratoTransportadorPayload => {
    return entity ?? { flAtivo: true };
  };

  const safeFilterContrato = (): ContratoTransportadorFilterPayload => {
    return {};
  };

  return {
    data,
    loading,
    searchContratos,
    getContrato,
    saveNewContrato,
    updateContrato,
    shelveContrato,
    safeContrato,
    safeFilterContrato
  };
};

export {
  useContratoTransportadorService,
  ContratoTransportadorPayload,
  ContratoTransportadorFilterPayload
};
